module.exports = __webpack_public_path__ + "static/img/アセット 34@2x.336e8de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 34@2x.png
// module id = RKu+
// module chunks = 1